import React from 'react';

import { Show, TextField, SimpleShowLayout, SelectField } from 'react-admin';

import { DateTimeField } from '../../../components/fields/DateFormatField';
import { JsonTextField } from '../../../components/fields/JsonTextField';
import { AdminActionName } from 'entities/AdminActionName';
import { useEnumSelectChoices } from 'components/_helpers/useEnumSelectChoices';
import { AdminActionActions } from './Actions';


export const AdminActionShow = (props) => {
	const adminActionChoices = useEnumSelectChoices(AdminActionName, '', false);

	return (
		<Show actions={<AdminActionActions />} {...props}>
			<SimpleShowLayout>
					<TextField source='id' />
					<SelectField source='name' choices={adminActionChoices} />
					<DateTimeField source='created_at' withLocalTimeZone />
					<JsonTextField source='data' label='resources.admin-actions.fields.data' />
			</SimpleShowLayout>
		</Show>
	);
};
